module.exports = __webpack_public_path__ + "img/Business.52fdb50d.png";